import styled from 'styled-components';

export const TableList = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 0px;
`;

export const TableBody = styled.tbody``;
